// extracted by mini-css-extract-plugin
export default {"frame":"style_frame__O1VDb","title":"style_title__bW74k","faqBottom":"style_faqBottom__CF2Ca","toggleWrapper":"style_toggleWrapper__yFwwx","faqArrow":"style_faqArrow__NIrUn"};